<template>
  <div class="card mgt-20px">
    <header class="header-card" >
      <p>{{ $t('addEditRegroupementProduit.information.title')}}</p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column is-6">
          <b-field
            v-if="!detail" class="obligatoire"
            :label="$t('addEditRegroupementProduit.information.code')">
            <b-input v-model.trim="regroupementProduit.code"></b-input>
          </b-field>
          <div v-else>
            <p class="has-text-default is-italic">
              {{ $t('addEditRegroupementProduit.information.code') }}
            </p>
            <p class="has-text-weight-bold">{{ regroupementProduit.code }}</p>
          </div>
        </div>
        <div class="column is-6">
          <b-field
            v-if="!detail" class="obligatoire"
            :label="$t('addEditRegroupementProduit.information.libelle')">
            <b-input v-model.trim="regroupementProduit.libelle"></b-input>
          </b-field>
          <div v-else>
            <p class="has-text-default is-italic">
              {{ $t('addEditRegroupementProduit.information.libelle') }}
            </p>
            <p class="has-text-weight-bold">{{ regroupementProduit.libelle }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { MARCHE } from '@/configuration/achat/permissionsConf';

export default {
  props: {
    regroupementProduit: {
      type: Object,
      required: true,
    },
    detail: {
      type: Boolean,
    },
  },
  data() {
    return {
      permissionTiers: MARCHE,
    };
  },
};
</script>
